import { render, staticRenderFns } from "./SicknessRequest.vue?vue&type=template&id=165d69b2&"
import script from "./SicknessRequest.vue?vue&type=script&lang=js&"
export * from "./SicknessRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports